import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CompetitionDocumentViewComponent = (props) => {
    const [documentList, setDocumentList] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    const { competitionIdParam } = useParams();

    useEffect(() => {
        setIsLoading(true);

        const getDocuments = async () => {
            await competitionService.getCompetitionDocumentList(props?.competition.id)
                .then((_docList) => {
                    // console.log("_docList: ", _docList);
                    let filteredList = _docList.filter(item => item.required)
                    setDocumentList(filteredList);
                    setIsLoading(false);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getDocuments();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, competitionIdParam]);



    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage("competition.document.title")}</h5>

                    {documentList && documentList.length > 0 &&
                        documentList.map((item, index) => (
                            <div key={index} className='flex align-items-center mb-3'>
                                <FontAwesomeIcon icon='fa-solid fa-square-check' size='xl' className="mr-2 icon-disabled" />
                                <div>{item.document}</div>
                            </div>
                        ))
                    }
                </div>
            </>
        );
    }
};

export default CompetitionDocumentViewComponent;
